import React, { useEffect, useRef } from 'react';

import type { MentorVideos } from '../../../../types/mentor';
import { useFacePosition } from '../../hooks/useFacePosition';

interface VideoStreamProps {
  hdVideo: MentorVideos | undefined;
  videoStream: MediaStream | null;
  videoRef?: React.RefObject<HTMLVideoElement | null>;
}

const VideoStream: React.FC<VideoStreamProps> = ({
  hdVideo,
  videoStream,
  videoRef: externalVideoRef,
}) => {
  const internalVideoRef = useRef<HTMLVideoElement>(null);
  const videoRef = externalVideoRef || internalVideoRef;
  const videoStyle = useFacePosition(hdVideo);

  useEffect(() => {
    if (videoRef.current) videoRef.current.srcObject = videoStream || null;
  }, [videoStream]);

  return (
    <>
      {videoStream && (
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          disablePictureInPicture={true}
          data-testid="avatar-main-video"
          style={videoStyle}
        />
      )}
    </>
  );
};

export default VideoStream;
